import app from './../app.js';  
import config from './../config.js';  
import Base_tools_class from './../core/base-tools.js';  
import Base_layers_class from './../core/base-layers.js';  
  
class Pan_class extends Base_tools_class {  
    constructor(ctx) {  
        super();  
        this.Base_layers = new Base_layers_class();  
        this.name = 'pan';  
        this.is_panning = false;  
        this.last_x = 0;  
        this.last_y = 0;  
        this.updatePending = false;  
    }  
  
    // Override shape methods to prevent selection  
    shape_mousedown(e) {}  
    shape_mousemove(e) {}  
    shape_mouseup(e) {}  
  
    load() {  
        this.default_events();  
    }  
  
    mousedown(e) {  
        var mouse = this.get_mouse_info(e);  
        if (mouse.click_valid == false) return;  
          
        this.is_panning = true;  
        this.last_x = mouse.x;  
        this.last_y = mouse.y;  
        document.body.style.cursor = 'grabbing';  
    }  
  
    mousemove(e) {  
        var mouse = this.get_mouse_info(e);  
        if (!this.is_panning) return;  

        var dx = mouse.x - this.last_x;  
        var dy = mouse.y - this.last_y;  

        // Accumulate deltas  
        this.accumulatedX = (this.accumulatedX || 0) + dx;  
        this.accumulatedY = (this.accumulatedY || 0) + dy;  

        this.last_x = mouse.x;  
        this.last_y = mouse.y;  

        // Throttle updates to frame rate  
        if (!this.updatePending) {  
            this.updatePending = true;  
            requestAnimationFrame(() => {  
                var zoom_data = app.GUI.GUI_preview.zoom_data;  
                zoom_data.move_pos = {  
                    x: -this.accumulatedX,  
                    y: -this.accumulatedY  
                };  
                config.need_render = true;  
                this.updatePending = false;  
            });  
        }  
    }
  
    mouseup(e) {  
        this.is_panning = false;  
        document.body.style.cursor = 'default';  
    }  
}  
  
export default Pan_class;